export default {
  level1:
    '0 1px 1px -1px rgba(0, 0, 0, 0.16), 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 0 2px 0 rgba(0, 0, 0, 0.1)',
  level2:
    '0 3px 1px -2px rgba(0, 0, 0, 0.16), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 1px 5px 0 rgba(0, 0, 0, 0.1)',
  level3:
    '0 2px 4px -1px rgba(0, 0, 0, 0.16), 0 4px 5px 0 rgba(0, 0, 0, 0.1), 0 1px 10px 0 rgba(0, 0, 0, 0.1)',
};
